import { Box, Flex, Image, Text } from "@chakra-ui/react"
import Logo from "assets/logo-hapvida-notredame.png"

const Header = () => {
  return (
	<Box w="full" position="relative">
		<Box h="80px" w="265px" right="calc(50% - 132.5px)" position="absolute" >
			<Image src={Logo} w="full" h="full" />
		</Box>
		<Flex alignItems="center" w="full" h="60px" px={12} backgroundColor="blue.600">
			<Text fontSize="xl"></Text>
		</Flex>
		<Box w="full" h="20px" backgroundColor="orange.500" />
	</Box>
  )
}

export default Header
